import React from "react";
import "./LoadingModal.css"; // Add CSS for styling
import Logo from "../../assets/perigigi_icon.png";
import UploadProgressLoading from "./UploadProgressLoading";

const LoadingModal = ({ open, uploadProgress, convertProgress }) => {
  const isUploading = uploadProgress && uploadProgress.length > 0;
  const isConverting = convertProgress && convertProgress.length > 0;

  return isUploading ? (
    <LoadingProgress open={open} uploadProgress={uploadProgress} />
  ) : isConverting ? (
    <LoadingProgress open={open} convertProgress={convertProgress} />
  ) : (
    <div
      className={`fixed ${
        open ? "" : "hidden"
      } z-40 inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full mx-auto`}
    >
      <div className="relative mx-auto p-5 w-3/4 rounded-md h-full overflow-hidden">
        <div className="ring flex justify-center bg-white p-10">
          <img src={Logo} alt="Loading" className="h-30" />
          <span className="spinner"></span>
        </div>
      </div>
    </div>
  );
};
const LoadingProgress = ({ open, uploadProgress, convertProgress }) => {
  const isUploading = uploadProgress && uploadProgress.length > 0;
  const isConverting = convertProgress && convertProgress.length > 0;
  return (
    <div
      className={`${
        !open ? "hidden" : ""
      } fixed z-40 inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center`}
    >
      <div className="relative mx-auto p-5 md:w-full md:max-w-xl rounded-md h-fit  bg-white shadow-xl xs:mx-8">
        <div className="flex items-center justify-start gap-4 mb-4">
          <img src={Logo} alt="Loading" className="h-12 w-12" />
          <div>
            <h2 className="text-lg font-semibold text-gray-800">
              {isConverting
                ? "Mohon tunggu...."
                : isUploading
                ? "Mengunggah File..."
                : "Memuat..."}
            </h2>
            {(isUploading || isConverting) && (
              <p className="md:text-sm xs:text-xs text-gray-500">
                Mohon tunggu hingga proses selesai.
              </p>
            )}
          </div>
        </div>

        {isConverting && (
          <div className="mb-6">
            <h3 className="md:text-sm xs:text-xs font-medium text-gray-700 mb-2">
              Sedang mengkonversi gambar
            </h3>
            <UploadProgressLoading uploadProgress={convertProgress} />
          </div>
        )}

        {isUploading && (
          <div>
            <h3 className="md:text-sm xs:text-xs font-medium text-gray-700 mb-2">
              Unggah File
            </h3>
            <UploadProgressLoading uploadProgress={uploadProgress} />
          </div>
        )}

        {!isUploading && !isConverting && (
          <div className="flex justify-center items-center h-20">
            <span className="spinner"></span>
          </div>
        )}
      </div>
    </div>
  );
};

export default LoadingModal;
